<template>
  <div id="roiAssessment">
    <b-container v-if="activePage" fluid class="w-100 p-0 roi-assessment">

      <!-- header section -->
      <b-row class="m-0 roi-header  mb-2 justify-content-center" >
        <b-col cols="12" md="11"  >
          <b-row v-if="showContactInfo" class="m-0">
            <b-col cols="12" md="8" class="p-0">
              <p class="title">ROI Assessment</p>
              <p class="sub-title">Return On Investment (ROI) Assessment tool provides a useful metric on how much you can benefit from implementing nuVizz Delivery Management platform.
                Please answer all the questions that resembles your business scenario. ROI has been derived from 
                the past history of customers using nuVizz platform.
              </p>
            </b-col>
            <b-col cols="12" md="4" class="roi-image text-center p-0">
              <div>
                <img :src="roiMainImage" alt="roi-main">
              </div>
            </b-col>
          </b-row>
          <b-row  v-else class="m-0">
            <b-col cols="12" md="8" class="p-0 py-3  ">
              <p class="title mb-0">Hi {{ contactInfo.name }}</p>
              
            </b-col>
            
          </b-row>
        </b-col>
      </b-row>
      <!-- main content section -->
      <b-row class="m-0 roi-content  justify-content-center" >
        <b-col cols="12" md="11"  class="p-0 pb-4" >
      

      <!-- About You-->

          <b-collapse id="contact-info" v-model="showContactInfo">
            <b-row class="m-0">
              <b-col cols="12" md="6" class="pt-3">
                <div role="group" class="ri-input-group">
                  <label for="contactName" class="mb-0">Full Name<span class="text-danger"> *</span></label>
                  <b-form-input
                    id="contactName"
                    class="ri-input-element"
                    v-model="contactInfo.name"
                    :state="nameState"
                    aria-describedby="contactName-help contactName-feedback"
                    placeholder=""
                    @input="contactNameValidation()"
                  ></b-form-input>
                  <span class="ri-input-append-icon">
                      <img :src="userIcon" />
                  </span>
                  <div v-if="nameState === null || nameState === true" class="null-state">
                  name
                  </div>
                  <!-- This will only be shown if the preceding input has an invalid state -->
                  <b-form-invalid-feedback id="contactName-feedback">
                    Please enter your full name
                  </b-form-invalid-feedback>

                
                </div>
                <div role="group" class="ri-input-group">
                  <label for="contactEmail" class="mb-0">Company Email <span class="text-danger"> *</span></label>
                  <b-form-input
                    id="contactEmail"
                    class="ri-input-element"
                    type="email"
                    v-model="contactInfo.email"
                    :state="emailState"
                    aria-describedby="contactEmail-help contactEmail-feedback"
                    placeholder=""
                    trim
                    @input="contactEmailValidation()"
                    
                  ></b-form-input>
                  <span class="ri-input-append-icon">
                      <img :src="emailIcon" />
                  </span>
                  <div v-if="emailState === null || emailState === true" class="null-state">
                  name
                  </div>
                  <!-- This will only be shown if the preceding input has an invalid state -->
                  <b-form-invalid-feedback id="contactEmail-feedback">
                    Please enter valid company email
                  </b-form-invalid-feedback>

                </div>
                <div role="group" class="ri-input-group ">
                  <label for="contactNumber" class="mb-0">Phone Number<span class="ri-font-size-12"> (Please include your country code)</span></label>
                  <b-form-input
                    id="contactNumber"
                    class="ri-input-element"
                    v-model="contactInfo.phoneNumber"
                    :state="phoneState"
                    aria-describedby="contactNumber-help contactNumber-feedback"
                    placeholder=""
                    trim
                    @keypress="isNumberValid($event)"
                    @input="contactPhoneValidation()"
                  ></b-form-input>
                  <span class="ri-input-append-icon">
                      <img :src="phoneIcon" />
                  </span>
                  <div v-if="phoneState === null || phoneState === true" class="null-state">
                  name
                  </div>
                  <!-- This will only be shown if the preceding input has an invalid state -->
                  <b-form-invalid-feedback id="contactNumber-feedback">
                    Please enter valid phone number
                  </b-form-invalid-feedback>

                
                </div>
                <div role="group" class="ri-input-group ">
                  <label for="contactCompany" class="mb-0">Company Name</label>
                  <b-form-input
                    id="contactCompany"
                    class="ri-input-element"
                    :state="companyState"
                    v-model="contactInfo.company"
                    placeholder=""
                    @input="contactCompanyValidation()"
                  ></b-form-input>

                  <span class="ri-input-append-icon">
                      <img :src="companyIcon" />
                  </span>

                
                </div>
              </b-col>
              <b-col cols="12" md="6" class="pt-3">
                <b-row class="m-0">
                  <b-col cols="12 p-0" >
                    <label for="contactCompany" class="mb-0">How do you describe your business <span class="text-danger"> *</span></label>

                  </b-col>
                  <b-col v-for="(industry,index) in industryOptions" class="pl-0 pb-3" :key="index" cols="6" md="4" @click="industrySelClick(industry)">
                    <div class="industry-card text-center py-1" :class="{'active': selIndustries.indexOf(industry.value) != -1}">
                      <span class=" pt-2 industry-icon d-inline-block ">
                        <img :src="industry.imageUrl" alt="industry-icon">
                        <!-- <img v-if="selIndustries.indexOf(industry.value) != -1" :src="industry.imageUrl" alt="industry-icon">
                        <img v-else :src="industry.greyUrl" alt="industry-icon"> -->
                      </span>
                      <p class="py-2 mb-0 ">
                        {{ industry.name }}
                      </p>
                      <span class="check-icon">
                        <img v-if="selIndustries.indexOf(industry.value) != -1" :src="radioTick" alt="industry-icon">
                        <img v-else :src="radioBtnOff" alt="industry-icon">

                      </span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

          </b-collapse>
        </b-col>

        <!-- Calculate -->
       
        <b-col  v-if="showContactInfo" cols="12" class=" text-center pb-3 " >
          <b-row class=" m-0 justify-content-start align-items-center ">
            <b-col cols="12" md="2" class=" offset-md-2 p-0 pt-2">
              <vue-recaptcha ref="recaptcha" :sitekey="reCaptchaSiteKey" @verify="onCaptchaVerify" @expired="onCaptchaExpired" @render="onCaptchaRendered" :loadRecaptchaScript="true"></vue-recaptcha>

            </b-col>
            <b-col cols="12" md="4" class="offset-md-0 text-center  p-0 pt-2">
              <button type="button" class="btn calc-btn btn-sm px-4 ml-4" @click="calculateClick()" :disabled="disableCalcBtn">Calculate</button>

            </b-col>
          </b-row>
         
        </b-col>


        <!-- ROI Basis -->
        <b-col v-if="!showContactInfo" cols="12" md="11"  class="p-0 roi-assessment-values "  >

          <b-row class="m-0">

            <!-- ROI Left Pane: Inputs -->

            <b-col cols="12" md="6" class=" roi-input-content">
              <p class="roi-calc-heading">Adjust your values</p>
             
              <!-- Routes/Day -->
              <b-form-group id="lbl-rtes-per-day"
                label="Average Routes Per Day"
                label-for="rtes-per-day" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left">
                <b-form-spinbutton id="rtes-per-day" 
                  v-model="rtesPerDay"  
                  min="10" max="5000" 
                  step="10" size="sm">
                </b-form-spinbutton>
              </b-form-group>
              <!-- Distance/Rte/Day -->
              <b-form-group id="lbl-dist-per-day"
                label="Distance (in miles) driven per route per day"
                label-for="dist-per-day" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left">
                <b-form-spinbutton id="dist-per-day" 
                  v-model="distPerRoute"  
                  min="100" max="600" 
                  step="50" size="sm">
                </b-form-spinbutton>
              </b-form-group>
              <!-- Stops/Day -->
              <b-form-group id="lbl-stops-per-day"
                label-for="stops-per-day" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left" 
                label="Number of deliveries/pickups (stops) per day">
                  <b-form-spinbutton id="stops-per-day" 
                    v-model="stopsPerDay"  
                    min="50" max="9000" 
                    step="50" size="sm">
                  </b-form-spinbutton>
              </b-form-group>
              <!-- Revenue/ Stop -->
              <b-form-group id="lbl-rev-per-stop"
                label-for="rev-per-stop" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left" 
                label="Average Revenue/Stop per day">
                  <b-form-spinbutton id="rev-per-stop" 
                    v-model="revPerStop"  
                    min="10" max="500" 
                    step="10" size="sm">
                  </b-form-spinbutton>
                </b-form-group>
              <!-- Dispatchers -->
              <b-form-group id="lbl-nbr-of-disp"
                label-for="nbr-of-disp" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left" 
                label="Number of Dispatchers">
                  <b-form-spinbutton id="nbr-of-disp" 
                    v-model="nbrOfDisp"  
                    min="1" max="10" 
                    step="1" size="sm">
                  </b-form-spinbutton>
                </b-form-group>

              <!-- Billers -->
              <b-form-group id="lbl-nbr-of-billers"
                label-for="nbr-of-billers" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left" 
                label="Number of Billing and Settlement Staff">
                  <b-form-spinbutton id="nbr-of-billers" 
                    v-model="nbrOfBiller"  
                    min="1" max="10" 
                    step="1" size="sm">
                  </b-form-spinbutton>
                </b-form-group>

              <!-- Customer Service Calls Per Day -->
              <b-form-group id="lbl-nbr-of-calls"
                label-for="nbr-of-calls" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left" 
                label="Customer Service Calls per Day">
                  <b-form-spinbutton id="nbr-of-calls" 
                    v-model="nbrOfCalls"  
                    min="50" max="1000" 
                    step="50" size="sm">
                  </b-form-spinbutton>
                </b-form-group>

              <!-- Nbr of Facilities -->
              <b-form-group id="lbl-nbr-of-facilities"
                label-for="nbr-of-facilities" 
                label-cols-sm="8"
                content-cols-sm="4"
                label-align="left" 
                label="Number of Shipping Facilities">
                  <b-form-spinbutton id="nbr-of-facilities" 
                    v-model="nbrOfFacilities"  
                    min="1" max="100" 
                    step="1" size="sm">
                  </b-form-spinbutton>
                </b-form-group>

              <!-- </b-container> -->
            </b-col>

            <!-- ROI Right Pane:  Results -->
              <b-col cols="12" md="6" class="roi-savings px-2">
                <b-row class="m-0">
                  <b-col cols="12" class="px-2 pb-2">
                    <p class=" m-0 roi-calc-heading">*Your Annual ROI Savings Per Shipping Facility</p>

                  </b-col>
                  <b-col cols="12" md="6" class="p-2">
                    <b-row class="m-0 h-100 roi-card cost-savings">
                      <b-col cols="12 py-2 px-2">
                        <span>
                          <img  height="26px" :src="dollarIcon" alt="roi-main">
                        </span>
                        <span class=" ml-2 roi-card-header">Annual Cost Savings</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Fuel Cost</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcFuelCostSaved}}</span>

                        </div>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Driver Pay</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcDrvPaySaved}}</span>

                        </div>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Dispatcher Pay</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcDispPaySaved}}</span>

                        </div>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Billing and Settlement Staff Pay</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcBillerPaySaved}}</span>

                        </div>
                      </b-col>
                      
                      <b-col cols="12" class=" mt-2 p-2 roi-card-total  align-items-center d-flex justify-content-between">
                        <label class="mb-0">Total Savings</label>
                        <div>
                          <span class="per-year">$</span>
                          <span>{{totalSavingsPerYear}}<span class="per-year">/year</span></span>

                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6" class="p-2">
                    <b-row class="m-0 h-100 roi-card improvements">
                      <b-col cols="12 py-2 px-2">
                        <span>
                          <img  height="26px" :src="timerIcon" alt="roi-main">
                        </span>
                        <span class=" ml-2 roi-card-header">Annual Key Metrics Savings</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Fuel in Gallons</label>
                        <span>{{calcFuelSaved}}</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Drive Time in Hrs</label>
                        <span>{{calcDrvHrsSaved}}</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Dispatcher Time in Hrs</label>
                        <span>{{calcDispHoursSaved}}</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Billing and Settlement Time in Hrs</label>
                        <span>{{calcBillerHoursSaved}}</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Customer Service Calls</label>
                        <span>Less than (&lt;) {{calcCallReduction }}</span>
                      </b-col>
                      
                      
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6" class="p-2">
                    <b-row class="m-0 pt-1  roi-card cash-flow align-items-">
                      <b-col cols="12 py-2 px-2">
                        <span>
                          <img  height="26px" :src="dollarArrIcon" alt="roi-main">
                        </span>
                        <span class=" ml-2 roi-card-header">Billing Improvements</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Gain from Proof of Delivery</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcLostPodRev}}</span>

                        </div>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Gain from reduced claims/audits</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcLostAuditRev}}</span>

                        </div>
                      </b-col>
                     
                      
                      
                      <b-col cols="12" class=" mt-2 p-2 roi-card-total  align-items-center d-flex justify-content-between">
                        <label class="mb-0">Total Recovered Revenue</label>
                        <div>
                          <span class="per-year">$</span><span>{{calcLostAuditRev + calcLostPodRev}}</span>
                          <span class="per-year">/year</span>
                        </div>
                        
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6" class="p-2">
                    <b-row class="m-0  pt-1 roi-card sustainability">
                      <b-col cols="12 py-2 px-2 d-flex">
                        <div>
                          <span>
                            <img  height="26px" :src="leavesIcon" alt="roi-main">
                          </span>
                        </div>
                       <div>
                        <p class=" ml-2 mb-0 d-block roi-card-header">Equivalent Sustainability Savings*</p>
                        <!-- <span class=" ml-2 roi-card-header">(EPA Estimated)</span> -->
                       </div>
                        

                      </b-col>
                      <!-- <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Fuel</label>
                        <span class="font-weight-bold">{{calcFuelSaved}} Gallons</span>
                      </b-col> -->
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Off Road Travel Miles</label>
                        <span >{{calcSustCarMiles}}</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content d-flex justify-content-between">
                        <label class="mb-0">Fuel Tankers</label>
                        <span >{{calcSustFuelTankers}}</span>
                      </b-col>
                      <b-col cols="12" class=" px-2 roi-card-content content-bbq d-flex justify-content-between">
                        <label class="mb-0">Propane Tanks for BBQ</label>
                        <span >{{calcSustPropaneTanks}}</span>
                      </b-col>
                      
                      
                      
                    </b-row>
                    <span class="estimate">* EPA Estimated</span>
                  </b-col>

                </b-row>
               
                  


               
              </b-col>
                

          </b-row>

      
        </b-col>
        <b-col v-if="!showContactInfo" cols="12" md="11" >
          <b-row  class="align-items-center m-0">
            <b-col  class="py-3 p-0">
              <p class="mb-0 mr-1 d-inline-block ri-font-size-14">Get detailed report on your email</p>
              <span class="ri-font-size-14 font-weight-bold">{{ contactInfo.email }}</span>
              <span class="cursor-pointer pr-2" @click="editContactInfo()"><img :src="editIcon" alt="edit-icon"/></span>
              <button type="button" class=" btn report-btn btn-sm px-4 "  @click="getReport()">Get Report</button>
            
            </b-col>
          </b-row>
        </b-col>

       
      </b-row>

      
      <!-- Disclaimer -->
      <b-row class="m-0 roi-footer  justify-content-center" >
        <b-col cols="12" md="11"  >
          <b-row class="m-0">
            <b-col cols="12" md="12" class="title py-2 p-0 ">
              <p class="mb-0">
                Note: The ROI presented is heuristic based model derived from prior experiences of nuVizz platform. nuVizz makes no guarantees that your specific implementation will derive the benefits outlined above. This does not constitute a written or verbal commitment on the solutions and use case and your ROI can be different from what is presented above.
              </p>
            </b-col>
            
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-else fluid class="w-100 p-0  ">

      <!-- header section -->
      <b-row class="m-0  roi-header roi-thank-you mb-2 align-items-center justify-content-center " >
        <b-col cols="12" md="11" class="text-center" >
            <p class="thanks-title">Thank You</p>
            <p class="ri-font-size-18">Thank you for submitting the request. You will receive an email with the detailed report.</p>
            <p class="ri-font-size-18">For more insights on last mile delivery ROI <button type="button" class="btn btn-sm b-radius-20 px-3  btn-light ml-2 "><a   class=" ri-font-size-18" href="https://nuvizz.com/roi-for-last-mile-delivery-management/">click here</a></button></p>
         
        </b-col>
      </b-row>
    </b-container>

        
    

  </div>
</template>

<script>

import axios from "axios"
import emailFileTxt from 'raw-loader!../non-valid-email-list.txt';
// import emailList from "../non-valid-email-list.txt"
import roiMainImage from '../assets/images/roi-main-image.svg'
import userIcon from '../assets/images/user-icon.svg'
import emailIcon from '../assets/images/email-icon.svg'
import phoneIcon from '../assets/images/phone-icon.svg'
import companyIcon from '../assets/images/company-icon.svg'
import radioTick from '../assets/images/radio-tick.svg'
import radioBtnOff from '../assets/images/radio-button-off.svg'
import dollarIcon from '../assets/images/dollar-icon.svg'
import dollarArrIcon from '../assets/images/dollar-arrow.svg'
import timerIcon from '../assets/images/timer.svg'
import leavesIcon from '../assets/images/earth-day-ecology.svg'
import editIcon from '../assets/images/edit-icon.svg'

import autoPartsIcon from '../assets/images/auto-parts.svg'
import autoPartsGreyIcon from '../assets/images/auto-parts-grey.svg'
import foodIcon from '../assets/images/food.svg'
import carrierIcon from '../assets/images/carrier.svg'
import freightIcon from '../assets/images/freight-forwarder.svg'
import medicineIcon from '../assets/images/medicine.svg'
import packageIcon from '../assets/images/package.svg'
import storeIcon from '../assets/images/store.svg'
import whiteGloveIcon from '../assets/images/white-glove.svg'
import whiteGloveGrey from '../assets/images/white-glove-grey.svg'
import carrierGrey from '../assets/images/carrier-grey.svg'
import freightGreyIcon from '../assets/images/freight-forwarder-grey.svg'
import packageGreyIcon from '../assets/images/package-grey.svg'
import storeGreyIcon from '../assets/images/store-grey.svg'
import foodGreyIcon from '../assets/images/food-grey.svg'
import medicineGreyIcon from '../assets/images/medicine-grey.svg'

import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'RoiAssessment',
  components:{
    VueRecaptcha
  },
  data ()  {
    return {
      roiMainImage,radioTick,radioBtnOff,dollarIcon,dollarArrIcon,timerIcon,leavesIcon,editIcon,
      autoPartsIcon,autoPartsGreyIcon,foodIcon,carrierIcon,freightIcon,medicineIcon,packageIcon,storeIcon,whiteGloveIcon,
      whiteGloveGrey,carrierGrey,freightGreyIcon,packageGreyIcon,storeGreyIcon,foodGreyIcon,medicineGreyIcon,
      userIcon,
      phoneIcon,
      companyIcon,
      emailIcon,
      // reCaptchaSiteKey:'6LdLNwEpAAAAADiRW8G_BAJSK_1kgqw7bp3wWmdP', 
      reCaptchaSiteKey:'6LeuKDkcAAAAABBs-_QlFuBWP66QPVtjQRsa_Agb',
      reCaptchaResponseToken: '',
      isCaptchaVerified: false,
      canValidateName:false,
      canValidateEmail:false,
      // selIndustry:'',
      contactInfo:{
        name:"", email:"", phoneNumber:"",company:""
      },

      nameState:false,
      emailState:false,
      phoneState:null,
      companyState:null,
      activePage:true,
      showContactInfo: true,
      canSubmit:false,
      selIndustries: [],
      emailsTxt:'',
      industryOptions: [
        { name:'Food Distribution',value:'Food Distribution', imageUrl:foodIcon, greyUrl:foodGreyIcon},
        { name:'Pharma/Health Care',value:'Pharma/Health Care',imageUrl:medicineIcon, greyUrl:medicineGreyIcon},
        { name:'White Glove Delivery', value:'White Glove Delivery',imageUrl:whiteGloveIcon, greyUrl:whiteGloveGrey},
        { name:'Auto Parts', value:'Auto Parts', imageUrl:autoPartsIcon, greyUrl:autoPartsGreyIcon},
        { name:'Freight Forwarder',value:'Freight Forwarder', imageUrl:freightIcon, greyUrl:freightGreyIcon},
        { name:'General Delivery',value:'General Delivery', imageUrl:packageIcon, greyUrl:packageGreyIcon},
        { name:'Carrier',value:'Carrier', imageUrl:carrierIcon, greyUrl:carrierGrey},
        { name:'Store Delivery',value:'Store Delivery', imageUrl:storeIcon, greyUrl:storeGreyIcon}
      ],
      rtesPerDay: 30,
      distPerRoute: 200,
      stopsPerDay: 500,
      revPerStop: 40,
      nbrOfDisp: 3,
      nbrOfBiller: 2,
      nbrOfCalls : 100,
      nbrOfFacilities: 1,
      nbrOfStoresPerWeek: 500,
      custServCallsPerDay: 100,
      defFuelPrice : 4.00,
      defMileageSavePerc : 0.11,
      defDispSavePerc: 0.25,
      defBillerSavePerc: 0.25 ,
      defDrvPayPerHour: 14.00 ,
      defDispPayPerHour: 14.00 ,
      defBillerPayPerHour: 14.00 ,
      defMPG: 11,
      defDaysPerMonth: 22,
      defHrsPerDay: 8,
      defLostPodPerc: 0.02,
      defAuditFailPerc: 0.02,
      defBillErrPerc :0.01,
      defBillLatePerc: 0.02,
      defDsoImproveDays: 10,
      defCustServCallPerc: 0.20,
      calcMilesDriven: 0,
      calcMilesSaved: 0,
      calcFuelSaved: 0,
      calcFuelCostSaved: 0,
      calcDrvHrsSaved: 0,
      calcDrvPaySaved: 0,
      calcDispPaySaved: 0,
      calcDispHoursSaved: 0,
      calcBillerHoursSaved: 0,
      calcBillerPaySaved: 0,
      calcLostPodRev: 0,
      calcLostAuditRev: 0,
      calcDsoCash: 0,
      calcBillErrCash: 0,
      calcBillLateCash: 0,
      calcSustCarMiles: 0,
      calcSustFuelTankers: 0,
      calcSustPropaneTanks: 0,
      totalSavingsPerYear: 0, 
      calcCallReduction: 0
    }
  },
  mounted(){
    // console.log('email text -->',emailFileTxt);
    this.emailsTxt = emailFileTxt.toString()
    console.log('email text <-->',this.emailsTxt);

  },
  computed: {
    
    
    invalidContactName() {
      if (this.contactName.length > 0) {
        return "Please enter atleast 5 characters"
      }
      return "Please enter your name"
    },
    
    // contactNUmberValidation(){
    //   if(this.contactInfo.phoneNumber.length > 0){
    //     var phoneRegex = 
    //   }else{
    //     return null
    //   }
      
    // },
    invalidContactEmail() {
      return "Enter Email to send your ROI details. We will not share it with anyone"
    },
    disableCalcBtn(){
      if (this.nameState && this.emailState && this.selIndustries.length >0 && this.isCaptchaVerified) {
        return false;
      } else {
        return true;
      }
    },
    

  },
  watch: {
    rtesPerDay:  function() { this.roiCalcs(); },
    distPerRoute:  function() { this.roiCalcs(); },
    stopsPerDay:  function() { this.roiCalcs(); },
    revPerStop:  function() { this.roiCalcs(); },
    nbrOfBiller:  function() { this.roiCalcs(); },
    nbrOfDisp:  function() { this.roiCalcs(); },
    nbrOfFacilities:  function() { this.roiCalcs(); },
    nbrOfCalls:  function() { this.roiCalcs(); }
  },
  methods: {
    onCaptchaRendered(id) {
    	let vm = this
      vm.isCaptchaVerified = false
      vm.reCaptchaResponseToken = ''
    },
    onCaptchaExpired() {
    	let vm = this
      vm.isCaptchaVerified = false
      vm.reCaptchaResponseToken = ''
      console.log('onCaptchaExpired -->');
    },
    onCaptchaVerify(response) {
    	let vm = this
    	vm.isCaptchaVerified = true
      vm.reCaptchaResponseToken = response
      // let formdata = new FormData()
      // formdata.set('secret','6LdLNwEpAAAAAE32eAPkbHzQUljeYHs7JE0DIVu-');
      // formdata.set('response',vm.reCaptchaResponseToken);
      // console.log('onCaptchaVerify ->',response);
		  
      // axios({
      //   method: "POST",
      //   url: "https://www.google.com/recaptcha/api/siteverify",
      //   data:formdata,
      //   headers: {
      //     'Content-Type': 'application/json',
      //   }
      // }).then(response => {
      //   if(response.data){
      //     console.log('captcha response data ->',response.data);
      //     // vm.activePage = false
         
      //   }else{
      //     vm.$awn.alert('Something went wrong, Please try again.');
      //     console.log("No data found.");
      //   }
      // }).catch(error =>{
      //   vm.$awn.alert('Something went wrong, Please try again.');
      //   console.error(error);
      // })
    },
    contactPhoneValidation(){
      if(this.contactInfo.phoneNumber){
        this.phoneState =  this.contactInfo.phoneNumber.length >= 10 ? true : false;
      }else{
      this.phoneState = null

      }
      
      // let emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      // if (this.contactInfo.email.length > 5 ) {
      //   this.emailState =  emailRegex.test(this.contactInfo.email);
        
      // }else{
      //   this.emailState = false
      // }
    },
    contactCompanyValidation(){
      if(this.contactInfo.company){
        this.companyState =  this.contactInfo.company.length > 0 ? true : false;

      }else{
        this.companyState = null
      }
    },
    isNumberValid(evt) {
      evt = evt ? evt : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode < 48 || charCode > 57) && charCode !== 43) {
          evt.preventDefault()
      } else {
          return true
      }
    },
    contactNameValidation() {
      this.nameState =  this.contactInfo.name.length > 0 ? true : false;
    },
    contactEmailValidation() {
      let state = false
      let emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      if (this.contactInfo.email.length > 5 ) {
        state =  emailRegex.test(this.contactInfo.email);
        if(state){
          // console.log('email validate text -->',this.emailsTxt.toString());
          let [email,domain] = this.contactInfo.email.split('@');
          // console.log('email domain ->',email,domain);
          this.emailState = (this.emailsTxt.toString().indexOf(domain) > -1) ? false : true;

        }
        
      }else{
        this.emailState = false
      }
      
    },
    editContactInfo(){
      console.log('editContactInfo ->');
      this.showContactInfo = true
    },
    getReport(){
      let vm = this
      let jsonData = JSON.stringify(vm.getRequestData()) 
      console.log('getReport -->',jsonData);

      // vm.activePage = false


      axios({
        method: "POST",
        url: "https://api.hsforms.com/submissions/v3/integration/submit/23571968/8edb2d2a-418d-4f53-b7c4-2e092e41815a",
        data:jsonData,
        headers: {
          'Content-Type': 'application/json',
        }
      }).then(response => {
        if(response.data){
          console.log('response data ->',response.data);
          vm.activePage = false
         
        }else{
          vm.$awn.alert('Something went wrong, Please try again.');
          console.log("No data found.");
        }
      }).catch(error =>{
        vm.$awn.alert('Something went wrong, Please try again.');
        console.error(error);
      })

    },
    getNameByTag(tag){
      let nameArr = this.contactInfo.name.split(' ')
      if(tag){
        return nameArr[0];
      }else{
        return nameArr && nameArr.slice(1,nameArr.length).join(' ')
      }
      
    },

    getRequestData(){
      let vm = this
      let reqData = {
        fields: [
          {
            name: 'firstname',
            value: vm.getNameByTag(true)
          },
          {
            name: 'lastname',
            value: vm.getNameByTag(false)
          },
          {
            name: 'email',
            value: vm.contactInfo.email
          },
          {
            name: 'company',
            value: vm.contactInfo.company
          },
          {
            name: 'how_do_you_characterize_your_business_',
            value: vm.selIndustries.toString()
          },
          {
            name: 'average_routes_per_day',
            value: vm.rtesPerDay
          },
          {
            name: 'nbr_of_dispatchers',
            value: vm.nbrOfDisp
          },
          {
            name: 'deliveries_per_day',
            value: vm.stopsPerDay
          },
          {
            name: 'average_miles_driven_per_route',
            value: vm.distPerRoute
          },
          {
            name: 'average_hrs_spent_in_billing_per_week',
            value: vm.nbrOfBiller
          },
          {
            name: 'average_revenue_per_stop',
            value: vm.revPerStop
          },
          {
            name: 'customer_service_calls_per_day',
            value: vm.nbrOfCalls
          },
          {
            name: 'number_of_facilities_shipping_locations',
            value: vm.nbrOfFacilities
          },
          {
            name: 'fuel_cost',
            value: vm.calcFuelCostSaved
          },
          {
            name: 'dispatcher_pay',
            value: vm.calcDispPaySaved
          },
          {
            name: 'biller_pay',
            value: vm.calcBillerPaySaved
          },
          {
            name: 'total_savings',
            value: vm.totalSavingsPerYear
          },
          {
            name: 'fuel_saved',
            value: vm.calcFuelSaved
          },
          {
            name: 'drive_time_saved',
            value: vm.calcDrvHrsSaved
          },
          {
            name: 'dispatch_time_saved',
            value: vm.calcDispHoursSaved
          },
          {
            name: 'accounting_time_saved',
            value: vm.calcBillerHoursSaved
          },
          {
            name: 'customer_service_calls',
            value: vm.calcCallReduction
          },
          {
            name: 'lost_proof_of_delivery',
            value: vm.calcLostPodRev
          },
          {
            name: 'lost_revenue_from_claims_audits',
            value: vm.calcLostAuditRev
          },
          {
            name: 'total_recovered_revenue',
            value: vm.calcLostAuditRev + vm.calcLostPodRev
          },
          {
            name: 'fuel', //Improvements
            value: vm.calcFuelSaved
          },
          {
            name: 'off_road_travel',
            value: vm.calcSustCarMiles
          },
          {
            name: 'fuel_tankers',
            value: vm.calcSustFuelTankers
          },
          {
            name: 'driver_pay',
            value: vm.calcDrvPaySaved
          },
          {
            name: 'propane_tanks_for_bbq',
            value: vm.calcSustPropaneTanks
          }
        ]
      }
      console.log('getRequestData ->',reqData);
      return reqData;
    },
    industrySelClick(industry){
      let vm = this
      console.log('industrySelClick  ->',industry);
      let index = vm.selIndustries.indexOf(industry.value);
      if(index != -1){
        vm.selIndustries.splice(index,1)
      }else{
        vm.selIndustries.push(industry.value)
      }
      console.log('selIndustries -->',vm.selIndustries);
      // this.selIndustry = industry.value
    },

    calculateClick() {
      let vm = this
      
      vm.showContactInfo = false;
      vm.roiCalcs()
     
    },
    roiCalcs() {
      if (!this.showContactInfo) {
        // this.canSubmit = true;
        console.log("roiCalcs called");

        // Fuel Savings
        this.calcMilesDriven = this.distPerRoute * this.rtesPerDay * this.defDaysPerMonth * 12
        this.calcFuelSaved = this.calcMilesDriven * this.defMileageSavePerc / this.defMPG
        this.calcFuelCostSaved = this.calcFuelSaved * this.defFuelPrice

        // Driving Hours Saved
        let origDrvHrs = this.rtesPerDay * this.defDaysPerMonth * this.defHrsPerDay * 12;
        let roiDrvHrs = origDrvHrs * 0.9;
        this.calcDrvHrsSaved = origDrvHrs - roiDrvHrs;
        this.calcDrvPaySaved = this.calcDrvHrsSaved * this.defDrvPayPerHour;

        // Dispatcher Savings
        this.calcDispHoursSaved = this.nbrOfDisp * this.defDaysPerMonth * this.defHrsPerDay * 12  * this.defDispSavePerc;
        this.calcDispPaySaved = this.calcDispHoursSaved * this.defDispPayPerHour ;

        // Biller Savings
        this.calcBillerHoursSaved = this.nbrOfBiller * this.defDaysPerMonth * this.defHrsPerDay * 12  * this.defBillerSavePerc;
        this.calcBillerPaySaved = this.calcBillerHoursSaved * this.defBillerPayPerHour;

        // Total Savings per year
        this.totalSavingsPerYear = this.calcFuelCostSaved + this.calcDrvPaySaved + this.calcDispPaySaved + this.calcBillerPaySaved

        // Recovered Revenue
        this.calcLostPodRev = this.revPerStop * this.stopsPerDay * this.defDaysPerMonth * 12 * this.defLostPodPerc;
        this.calcLostAuditRev = this.revPerStop * this.stopsPerDay * this.defDaysPerMonth * 12 * this.defAuditFailPerc;

        // Cash Flow Improvement
        this.calcDsoCash = this.stopsPerDay * this.revPerStop * this.defDsoImproveDays;
        this.calcBillErrCash = this.stopsPerDay * this.revPerStop * this.defDaysPerMonth * 12 * this.defBillErrPerc ;
        this.calcBillLateCash = this.stopsPerDay * this.revPerStop * this.defDaysPerMonth * 12 * this.defBillLatePerc;

        // Call Reduction
        this.calcCallReduction = this.nbrOfCalls * this.defCustServCallPerc;

        // Sustainability Savings
        // Metrics from EPA.org
        this.calcSustCarMiles = parseFloat(this.calcFuelSaved * 26.1).toFixed(2)
        this.calcSustFuelTankers = parseFloat(this.calcFuelSaved / 7415).toFixed(2)
        this.calcSustPropaneTanks = parseFloat(this.calcFuelSaved * 2.13).toFixed(2)
      }
    }
  }
}
</script>

